import makeService from '~/services/api';

export default makeService('/crosssell');
